import { type Locale, resolveLocale } from '@upme/i18n';

export const LOCALE_CACHE_KEY = 'upme.admin.locale';

export function detectAdminLocale(): Locale {
  try {
    const cached = localStorage.getItem(LOCALE_CACHE_KEY);
    if (cached) return resolveLocale(cached);
  } catch {
    // ignore
  }

  // i18n-autodetect: временно выключен (переводы тестируют только админы).
  // Вернуть целиком — см. docs/superpowers/specs/2026-07-27-i18n-ru-default-admin-only-switch-design.md
  //
  // if (typeof navigator !== 'undefined' && navigator.language) {
  //   return resolveLocale(navigator.language);
  // }

  return 'ru';
}
